import { Form, Input, Modal, Select, Upload, message } from "antd";
import { useEffect, useRef, useState } from "react";
import { InboxOutlined } from "@ant-design/icons";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { user_role } from '../../consts';
import DropDown from '../../pages/DropDown';
import CreateClient from "../../pages/createClient";
// import { DatePicker } from "antd";
import { Divider } from "antd";
import RequestEntity from "../../pages/requestEntity";
import RequestFyDoc from "../../pages/RequestFyInDoc";
import { useCreateDocument, useGetAllClients, useGetAllFinancialYears, useGetAllFolders } from "../../utils/queryUtils";

import useFetch from "../../_fetch";
import { setReloadComment, setReloadDocument } from "../../store/action/reload";

const { Dragger } = Upload;
const { Option } = Select;

const layout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

export default function SendDocumentsModal({ open, setOpen, setToggle }) {


  // const { selected: selecteCompany } = useSelector(st => st.company || {});
  // const [entitydisplay, setEntitydisplay] = useState("none");
  // const [addoldentity, setAddoldentiy] = useState("none");
  // const selectedFinancialYear = useSelector(state => state.selectedFinancialYear);
  // const { fy: selectedFinancialYear } = useSelector(state => state.selected)
  // const { selected: selectedClient, all: all_clients } = useSelector(
  //   (st) => st.client || {}
  // );
  // const { selected, grouped: all_fys } = useSelector((st) => st.fy || {});
  // const selectedFY = useSelector(state => state.client.selectedFY || {});

  const [oldentity] = useState("block");
  const [addnewentity] = useState("block");
  const [financialYear] = useState(true);
  const [_, setFolderData] = useState([]);
  const dispatch = useDispatch()
  const [newFolder, setNewFolder] = useState(false);
  const [clientData, setClientData] = useState([]);
  const [addClientModalVisible, setAddClientModalVisible] = useState(false);
  const [openEntityModal, setOpenEntityModal] = useState(false);
  const [abn, setAbn] = useState('');
  const user = useSelector(st => st.user);
  const [fydata, setFydata] = useState([]);
  const [__, setFyField] = useState(false);
  const [folderField, setFolderField] = useState(true);
  const [docPage] = useState(1);

  const { company: selectedCompany } = useSelector(st => st.selected)
  const { client: selectedClient } = useSelector(state => state.selected)
  const [Client, setClient] = useState(selectedClient);
  const { fy: selectedFy } = useSelector(st => st.selected)
  const [fy_id, setFy_id] = useState(selectedFy?._id);
  // const [fy, setFy] = useState(null);

  const clientsdatacache = useGetAllClients(selectedCompany?.name)
  const all_clients = clientsdatacache?.data?.data
  const allfyscache = useGetAllFinancialYears(Client)
  // const { data: all_fys } = useGetAllFinancialYears(Client);
  const all_fys = allfyscache?.data
  useEffect(() => {
    setFydata(all_fys?.data);
  }, [all_fys])
  useEffect(() => {
    allfyscache.refetch();
    setFydata(all_fys?.data);
  }, [Client])

  useEffect(() => {
    if (selectedClient) {
      setClient(selectedClient)
    }
    if (selectedFy) {
      setFy_id(selectedFy._id)
    }
  }, [selectedClient, selectedFy])

  const { data: all_folders } = useGetAllFolders(fy_id);
  const filesRef = useRef([]);
  const [loading, setLoading] = useState(false);
  const _fetch = useFetch();
  const [form] = Form.useForm();
  const { mutateAsync: createDocument, isSuccess: createDocumentSuccess } = useCreateDocument();

  const Reload = (ev) => {
    ev.preventDefault();
    return (ev.returnValue = "Are you sure you want to close?");
  };

  const upload = async (file, url, document_id, resolve, reject) => {
    try {
      let options;
      let contentType = "";
      contentType = file.type;
      options = {
        method: "PUT",
        headers: {
          "Content-Type": contentType,
        },
        body: file,
      };

      let res = await fetch(url, options);
      if (res.status === 200) {
        try {
          let parsedUrl = new URL(url);
          let pathname = parsedUrl.pathname.slice(1);
          let uploadedRes = await _fetch(
            `${process.env.REACT_APP_API_URL}/file`,
            {
              method: "POST",
              body: {
                document_id,
                path: pathname,
                type: contentType,
              },
            }
          );
          if (uploadedRes.status === 200) {
            uploadedRes = await uploadedRes.json();
            resolve(file.uid);
            setToggle((pre) => !pre)
          }
        } catch (e) {
          console.error(e);
          reject(e);
        }
      }
    } catch (e) {
      console.error(e);
      reject(e);
    }
  };

  async function getUploadUrl(file, id, d_id, status) {
    const fileParts = file.name.split(".");
    fileParts.pop();
    let name = fileParts.join(".");
    let ext = file.name.split(".").pop();
    name = `${name}-${moment().valueOf()}.${ext}`;
    let url;
    url = await _fetch(
      `${process.env.REACT_APP_API_URL}/file/get_upload_url?name=${name}&fy=${id}`
    )
    if (url) {
      url = await url.json();
      return url;
    } else {
      console.error("url to upload generation failed");
      throw new Error("url to upload generation failed");
    }
  }



  async function getFolder(name) {
    let body = {
      name: name,
      fy_id,

    }
    try {
      let res = await _fetch(`${process.env.REACT_APP_API_URL}/folder`,
        {
          method: 'POST',
          body
        }
      );
      let data = await res.json();
      if (data) {
        return data._id
      } else {
        console.error(data)
        message.error(data.response);
      }
    }
    catch (e) {
      console.error(e);
    }
  }

  async function submit(values) {

    // window.addEventListener("beforeunload", Reload);
    try {

      setLoading(true);

      if (!values?.files?.fileList?.length) {
        message.info("Please upload file");
        setLoading(false);
        return
      }
      if ((!values.financialYear && !values.proposedfy && !values.proposefinancialYear) ||
        (!values.new_folder && !values.folder_id) ||
        (!values.proposedentity && !values.client_id)
      ) {
        message.info("Fill Properly");
        setLoading(false);
        return
      }
      let folder
      if (values.new_folder && values.financialYear) {
        folder = await getFolder(values.new_folder);
      }
      else {
        folder = values.new_folder;
      }
      let k = {
        fy_id: values.financialYear,
        // status: "confirmed",
        company: selectedCompany?._id,
        company_id: selectedCompany?._id,
        folder_id: !values.new_folder ? values.folder_id : folder,
        folderName: values?.new_folder,
        abn: abn.val,
        client_id: Client?._id
      }
      const body = {
        ...k,
        comment: values.comment,
        page: docPage
      }
      let createdDocument = await createDocument(body);


      if (createdDocument || createDocumentSuccess) {
        const document_id = createdDocument?._id;
        let promises = [];
        for (let i = 0; i < filesRef.current.length; i += 1) {
          let file = filesRef.current[i];
          promises[i] = new Promise(async function (resolve, reject) {
            let url = await getUploadUrl(file, values.financialYear, document_id);
            if (url) upload(file, url, document_id, resolve, reject);
          });
          Promise.all(promises)
            .then((values) => {
              if (values.length === filesRef.current.length) {
                message.success("Documents Submitted");
                form.resetFields();
                window.removeEventListener("beforeunload", Reload);
                setLoading(false);
                setOpen(false);
                filesRef.current = []
              }
            })
            .catch((e) => {
              message.error(e);
              window.removeEventListener("beforeunload", Reload);
              setLoading(false);
              form.resetFields();
              filesRef.current = []
            });
        }
      }

      if (createdDocument != null || createDocumentSuccess) {
        message.success("Documents Submitted");
        form.resetFields();
        dispatch(setReloadComment(true))
        dispatch(setReloadDocument(true))
        window.removeEventListener("beforeunload", Reload);
        filesRef.current = []
        setLoading(false);
        setOpen(false);
        setNewFolder((prev) => {
          prev = false;
          return prev;
        })
      }

      // else {
      //   message.error(createdDocument.response);
      //   setLoading(false);
      //   form.resetFields();
      //   filesRef.current = []
      // }

    } catch (e) {
      console.error(e)
      message.error(e);
      window.removeEventListener("beforeunload", Reload);
      setLoading(false);
      form.resetFields();
      filesRef.current = []
    }
    finally {
      setLoading(false);
      // setOpen(false);
    }
  }

  const props = {
    multiple: true,
    showUploadList: {
      showPreviewIcon: false,
    },
    listType: "picture-card",
    beforeUpload: async (file) => {
      filesRef.current.push(file);
      return false;
    },
    onRemove: (file) => {
      filesRef.current = filesRef.current.filter((e) => e.uid !== file.uid);

    },
  };

  const folderDataFetch = async () => {
    if (!fy_id || !open || newFolder) return
    try {
      let res = await _fetch(`${process.env.REACT_APP_API_URL}/folder?fy_id=${fy_id}`)
      res = await res.json();
      if (res.success) {
        setFolderData(res.response)
      }
      else {
        console.error(res.response);
        message.error("Failed to fetch folders");
      }
    } catch (e) {
      message.error("Something went wrong")
      console.error(e);
    }
  }

  useEffect(() => {
    folderDataFetch()
  }, [fy_id])

  useEffect(() => {
    let clientData = all_clients?.filter((el) => el.title);
    setClientData(clientData)
  }, [all_clients])

  return (
    <Modal
      style={{ marginTop: "-97px" }}
      open={open}
      onCancel={() => setOpen(false)}
      okText="Submit"
      onOk={form.submit}
      // confirmLoading={loading}
      afterClose={() => form.resetFields()}
      destroyOnClose={true}
      title="Submit New Documents">
      <Form

        preserve={false}
        layout="vertical"
        {...layout}
        form={form}
        onFinish={submit}>

        <Form.Item name="files">

          <Dragger {...props}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click or drag file to this area to upload documents
            </p>
          </Dragger>
        </Form.Item>

        <div style={{ display: `${oldentity}` }}>
          <Form.Item
            key={Client?._id}
            label={<div className="finanicalYears" ><p
              style={{ width: "200px", display: `${addnewentity}`, alignItems: "center", justifyContent: "center", marginBottom: "0px" }}>
              Entity
            </p>
            </div>
            }
            name="client_id"
            initialValue={Client?._id}
          >
            <Select
              value={Client?._id}
              showSearch
              onChange={(value, val) => {
                setClient({ _id: value, abn: val?.val });
                setAbn(val);
                setFyField(false);
                setFolderField(true);
              }}


              optionFilterProp="label"
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Divider
                    style={{
                      margin: '8px 0',
                    }}
                  />
                  {
                    user.role === user_role.ADMIN && user_role.ACCOUNTANT && (
                      <button className="m-2" style={{ color: '#1677ff', border: 'none', background: 'transparent' }}
                        onClick={() => setAddClientModalVisible(true)}
                      >
                        Add Entity
                      </button>

                    )
                  }
                  {
                    user.role !== user_role.ADMIN && user_role.ACCOUNTANT && (
                      <button className="m-2" style={{ color: '#1677ff', border: 'none', background: 'transparent' }}
                        onClick={() => setOpenEntityModal(true)}
                      >
                        Request Entity
                      </button>
                    )}
                </>
              )}
            >
              {clientData?.map((e) => {
                return (
                  <Option
                    value={e?._id}
                    val={e?.abn}
                    key={e?._id}
                    label={e?.title}>
                    {e?.title}

                  </Option>
                )
              })}
            </Select>
          </Form.Item>

          <Form.Item
            key={fy_id?._id}
            style={{ width: "150px" }}
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.client_id !== currentValues.client_id
            }>

            {({ getFieldValue, setFieldsValue }) => {
              let value = fydata?.find((e) => e?._id === getFieldValue("client_id"));
              return (
                // `${moment(
                //   selectedFy.start
                // ).format("YYYY")}-${moment(selectedFy.end).format("YY")}` 
                < Form.Item
                  label={< div className="finanicalYears" > <p
                    style={{ width: "200px", display: `${addnewentity}`, alignItems: "center", justifyContent: "center", marginBottom: "0px" }}>
                    Financial Year</p>

                  </div>}
                  name="financialYear"
                  initialValue={selectedFy ? selectedFy?._id : null}>
                  <Select value={fy_id}
                    disabled={Client || selectedClient ? false : true}
                    onChange={(value) => {
                      setFy_id(value);
                      setFolderField(false);
                      // setFy(value);
                      // refetchFolders();
                    }}
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        <Divider
                          style={{
                            margin: '8px 0',
                          }}
                        />
                        {
                          user.role === user_role.ADMIN || user_role.ACCOUNTANT && (
                            <DropDown client_id={Client?._id}
                              setClient_id={setClient}
                              returnSelected={(end) => setFieldsValue({ financialYear: end })} />

                          )
                        }
                        {
                          user.role !== user_role.ADMIN && user.role !== user_role.ACCOUNTANT && (
                            <RequestFyDoc
                              abn={abn.val}
                              setAbn={setAbn}
                              Client_id={Client?._id}
                              setClient_id={setClient}

                            />

                          )
                        }
                      </>

                    )}
                  >
                    {
                      fydata?.map((e) => (
                        <Option
                          value={e._id}
                          key={e._id}
                          label={e.financial_year}
                        >

                          {moment(e.start).format("YYYY")} -{" "}
                          {moment(e.end).format("YY")}
                        </Option>

                      ))}
                  </Select>
                </Form.Item>
              )
            }}
          </Form.Item>
        </div >

        {
          !newFolder && financialYear ?
            <Form.Item
              style={{ width: "150px" }}
              noStyle
              shouldUpdate={(prevValues, currentValues) => {
                return prevValues.financialYear !== currentValues.financialYear
              }}
            >
              {({ getFieldValue }) => {
                // setFy_id(getFieldValue('financialYear'));
                return (
                  <Form.Item
                    label={<div className="finanicalYears" ><p
                      style={{ width: "200px", display: `${addnewentity}`, alignItems: "center", justifyContent: "center", marginBottom: "0px" }}>
                      Folder</p>

                    </div>}
                    name="folder_id"
                    initialValue={all_folders?.[0] !== undefined ? all_folders?.[0]._id : null}
                  >
                    <Select
                      value={all_folders?.[0] !== undefined ? all_folders?.[0]._id : null}
                      disabled={fy_id || selectedFy ? false : true}
                      onChange={(value) => {
                        setFolderData(value);
                        // refetchFolders();
                      }}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          <Divider
                            style={{
                              margin: '8px 0',
                            }}
                          />
                          <button className="m-2" style={{ color: '#1677ff', border: 'none', background: 'transparent' }}
                            onClick={() => setNewFolder((prev) => {
                              prev = true;
                              return prev
                            })}>Create folder
                          </button>
                        </>
                      )}
                    >
                      {all_folders && all_folders.map((e) => (
                        <Option
                          value={e._id}
                          key={e._id}
                          label={e.name}>
                          {e.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                )
              }}
            </Form.Item>
            :

            <Form.Item
              label={
                <div className="finanicalYears" ><p
                  style={{ width: "200px", display: 'block', alignItems: "center", justifyContent: "center", marginBottom: "0px" }}>
                  Create Folder</p>

                </div>
              }
              name="new_folder"
            >
              <Input />
            </Form.Item>

        }
        <Form.Item
          label="Comment"
          name="comment">
          <Input.TextArea
            placeholder="type your comment..."
            autoSize={{
              minRows: 3,
              maxRows: 10,
            }}
          />
        </Form.Item>
      </Form >
      {
        openEntityModal ? <RequestEntity
          visible={openEntityModal}
          setVisible={setOpenEntityModal}
        /> : null}

      {
        addClientModalVisible ? <CreateClient
          visible={addClientModalVisible}
          setVisible={setAddClientModalVisible}
        /> : null
      }

    </Modal >


  );
}
